<!-- Loader global -->
<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="logs-page-container">
  <div class="logs-content-wrapper">
      <!-- Tableau crons -->
      <div class="logs-table-container">
        <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4 relative">
          <!-- Filtre de recherche centré avec nombre de résultats à droite -->
          <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
            <div class="relative w-full max-w-xs">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
              <input
                type="text"
                class="search-input-cron w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                [(ngModel)]="searchTerm"
                placeholder="Rechercher par nom..."
              />
            </div>
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
              {{ filtered.length }} cron{{ filtered.length > 1 ? 's' : '' }}
            </span>
          </div>
        </div>

        <!-- Message d'erreur -->
        <div *ngIf="errorMessage" class="px-6 py-3 bg-red-50 border-b border-red-200">
          <p class="text-sm text-red-700">{{ errorMessage }}</p>
        </div>

        <div class="overflow-x-auto">
          <table class="logs-table">
            <thead class="logs-table-header">
              <tr>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[200px] text-center" (click)="toggleSort('name')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Nom</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'name' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'name'">↕</span>
                      <span *ngIf="sortField === 'name' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'name' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[150px] text-center" (click)="toggleSort('intervalle')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Intervalle</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'intervalle' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'intervalle'">↕</span>
                      <span *ngIf="sortField === 'intervalle' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'intervalle' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[200px] text-center" (click)="toggleSort('timestamp')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Dernière exécution</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'timestamp' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'timestamp'">↕</span>
                      <span *ngIf="sortField === 'timestamp' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'timestamp' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let cron of filtered; trackBy: trackByCron" class="logs-table-row">
                <td class="logs-table-cell font-medium text-gray-800 text-center">
                  {{ cron.name }}
                </td>
                <td class="logs-table-cell text-center">
                  {{ getUsageIntervalLabel(cron) }}
                </td>
                <td class="logs-table-cell text-center">
                  {{ cron.timestamp ? (cron.timestamp | date:'short') : 'Jamais' }}
                </td>
              </tr>
              <tr *ngIf="!isLoading && !errorMessage && filtered.length === 0" class="logs-table-row">
                <td colspan="3" class="logs-table-cell text-center text-gray-500">
                  <span *ngIf="searchTerm">Aucun résultat trouvé pour "{{ searchTerm }}"</span>
                  <span *ngIf="!searchTerm">Aucun cron n'a encore été enregistré.</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>

<!-- Modale pour ajouter un cron -->
<div class="users-modal-overlay" *ngIf="showAddCronModal">
  <div class="users-modal-content" #addCronModalContent>
    <!-- Header de la modale -->
    <div class="users-modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">schedule</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Ajouter un cron</h2>
      </div>
      <button 
        class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
        (click)="closeAddCronModal()" 
        type="button"
        [disabled]="isAdding">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <!-- Body de la modale -->
    <div class="users-modal-body">
      <form (ngSubmit)="addCron(); $event.preventDefault()" id="addCronForm">
        <!-- Section principale -->
        <div class="mb-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Nom -->
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                Nom
                <span class="text-red-500">*</span>
              </label>
              <input 
                type="text" 
                class="users-form-input" 
                [(ngModel)]="cron.name" 
                name="name" 
                placeholder="Nom du cron" 
                required 
                tabindex="1"
                autofocus />
            </div>
            
            <!-- Intervalle -->
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                Intervalle (en ms)
                <span class="text-red-500">*</span>
              </label>
              <input 
                type="number" 
                class="users-form-input" 
                [(ngModel)]="cron.usageInterval" 
                name="usageInterval" 
                placeholder="Ex: 60000 pour 1 minute" 
                min="1000"
                required 
                tabindex="2" />
            </div>
          </div>
        </div>
      </form>
    </div>
    
    <!-- Footer de la modale -->
    <div class="users-modal-footer">
      <button 
        type="button" 
        class="users-btn-secondary" 
        (click)="closeAddCronModal()"
        [disabled]="isAdding">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="users-btn-primary" 
        form="addCronForm"
        [disabled]="isAdding">
        <span *ngIf="!isAdding" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">add</span>
          <span>Ajouter le cron</span>
        </span>
        <span *ngIf="isAdding" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Création en cours...</span>
        </span>
      </button>
    </div>
</div>
